export default __webpack_public_path__ + "static/media/php.53c03f24.png";